<template>
  <div>
    <div class="d-flex">
      <div class="flex-grow-1">
        <div class="d-flex justify-content-start align-items-center">
          <div>
            <div class="professional-profile-name">{{ professional.name | firstName }}</div>
          </div>
          <div>
            <cleaner-badges :professional="professional"/>
          </div>
        </div>
        <div class="pt-1">
          {{ globalState.cities[professional.province_id] | multiLangName }} ·
          {{ $t('message.professional.joined_in') }}
          {{ professional.create_date | joinedDate }}
        </div>
        <div class="pt-2" v-if="professional.rating && professional.rating > 0 || professional.job_qty > 0">
          <template v-if="professional.rating && professional.rating > 0">
            <i class="fas fa-star -rating-star"></i> {{ Number(professional.rating).toFixed(1) }}
            ·
            <span v-if="isActiveReviewLink">
              {{ isActiveReviewLink }}
              <a class="text-primary-link" href="#" v-scroll-to="{el:'#professional-reviews',offset: -20}">{{ professional.rating_qty }} {{ $tc('message.professional.review', professional.rating_qty) }}</a>
            </span>
            <span v-else>{{ professional.rating_qty }} {{ $tc('message.professional.review', professional.rating_qty) }}</span>
            ·
          </template>
          <template v-if="professional.job_qty > 0">
            {{ professional.job_qty | numberWithCommas }} {{ $tc('message.professional.job', professional.job_qty) }}
          </template>
        </div>
      </div>
      <div class="pl-3">
        <professional-picture :professional="professional"
                              :imgClass="'img-fluid'"
                              :imgSize="64"/>
      </div>
    </div>
    <div class="py-2" v-if="professional.is_excellent === 1">
      <router-link to="/excellent-provider">
        <img src="/static/img/ic_badge_excellent.png"
             width="28"
             v-b-popover.hover.top="$i18n.t('message.professional.excellent_provider_detail', {name: firstName(professional.name)})"
             :title="$i18n.t('message.professional.excellent_provider_title')">
      </router-link>
      {{ $t('message.professional.excellent_provider_title') }}
    </div>
    <!-- Vaccination section -->
    <professional-vaccination :professional="professional"/>
    <hr class="mb-0">
    <!-- Stats section -->
    <div class="pt-3">
      <div v-if="professional.repeat_booking_rate > 0">
        {{ $t('message.professional.repeat_booking_rate') }}:
        <label>{{ professional.repeat_booking_rate }}%</label>
      </div>
      <div>{{ $t('message.professional.response_rate') }}:
        <label>100%</label>
      </div>
      <div v-if="professional.response_time">
        {{ $t('message.professional.response_time') }}:
        <label class="mb-0">
          <span v-html="$options.filters.responseTime(professional.response_time)"></span>
        </label>
      </div>
    </div>
  </div>

</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import CleanerBadges from './CleanerBadges'
  import ProfessionalPicture from './ProfessionalPicture'
  import ProfessionalVaccination from './ProfessionalVaccination'

  export default {
    props: {
      professional: Object,
      isActiveReviewLink: {
        type: Boolean,
        default: true
      }
    },
    components: {
      CleanerBadges,
      ProfessionalPicture,
      ProfessionalVaccination
    },
    computed: {
      ...mapState('professional', ['hasPaidOrder']),
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      firstName (professionalName) {
        return this.$options.filters.firstName(professionalName)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/components/CleanerProfileMobile.vue